<template>
  <div
    class="multi-store-form"
    :class="{
      'multi-store-form--light': formTheme === 'light',
      'multi-store-form--large': formTheme === 'large'
    }"
  >
    <form
      :id="`${formId}_localization_form`"
      ref="form"
      class="multi-store-form__form"
      method="post"
      action="/localization"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
    >
      <input
        type="hidden"
        name="form_type"
        value="localization"
      >

      <input
        type="hidden"
        name="utf8"
        value="✓"
      >

      <input
        type="hidden"
        name="_method"
        value="put"
      >

      <input
        type="hidden"
        name="return_to"
        :value="`${$variable('request.origin')}${$variable('request.path')}`"
      >

      <label
        :for="`${formId}_country_code`"
        class="multi-store-form__image-wrapper"
      >
        <span
          class="visually-hidden"
          v-text="$string('general.site_header.select_country')"
        />

        <!-- eslint-disable-next-line vue/no-restricted-html-elements -->
        <img
          class="multi-store-form__image"
          :alt="currentCountry.name"
          :src="flagSrc"
          height="41"
          width="54"
        >
      </label>

      <div class="form-group">
        <select
          :id="`${formId}_country_code`"
          ref="select"
          v-model="currentCountryCode"
          class="multi-store-form__select"
          name="country_code"
          @change="handleChange"
        >
          <option
            v-for="country of $variable('store.availableCountries')"
            :key="country.isoCode"
            :value="country.isoCode"
            v-html="country.name"
          />
        </select>
      </div>
    </form>
  </div>
</template>

<script>

/**
 * Vue: Multi store form (multi-store-form)
 * -----------------------------------------------------------------------------
 * Localization form selects with options.
 *
 * @param {String} formId - Unique ID prefix.
 * @param {String} [formTheme] - Theme for form.
 *
 */
export default {
  name: 'MultiStoreForm',

  props: {
    formId: {
      type: String,
      default: '',
      required: true,
    },
    formTheme: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      cnvsGlobal: true,
      currentCountryCode: this.$variable('store.country'),
    }
  },

  computed: {

    /**
     * Compute current country object.
     * @returns {Object}
     */
    currentCountry() {
      return this.$variable('store.availableCountries').find((country) => {
        return country.isoCode === this.currentCountryCode
      })
    },

    /**
     * Compute flag src.
     * @returns {String}
     */
    flagSrc() {
      const code = this.currentCountryCode?.toLowerCase()
      return `//cdn.shopify.com/static/images/flags/${code}.svg`
    },
  },

  watch: {

    /**
     * Watch current country code update to submit form.
     */
    async currentCountryCode() {
      await this.setSelectWidth()
      this.$refs.form.submit()
    },
  },

  mounted() {
    this.setSelectWidth()
  },

  methods: {

    /**
     * Set width of sort element based on select option.
     */
    async setSelectWidth() {
      const select = this.$refs.select

      if (!select) {
        return
      }

      await this.$nextTick()

      /**
       * Create element to read width from.
       */
      const widthElement = document.createElement('span')

      const textClass = this.formTheme === 'large'
        ? 'text-body-s-regular'
        : 'text-body-xs-regular'

      widthElement.classList.add(textClass)
      widthElement.innerHTML = select.options[select.selectedIndex].text || ''
      document.body.appendChild(widthElement)

      const width = widthElement.offsetWidth
      document.body.removeChild(widthElement)

      if (width === 0) {
        return
      }

      /**
       * Set width.
       */
      select.style.width = `calc(${width}px + var(--icon-m) + var(--spacing-m))`
    },
  },
}
</script>
